var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.items,"prepend-icon":"mdi-list-status","item-text":"text","item-value":"result","label":_vm.$t('result'),"filled":"","hide-details":"","solo-inverted":""},on:{"change":_vm.setSelectResult},model:{value:(_vm.select),callback:function ($$v) {_vm.select=$$v},expression:"select"}})
}
var staticRenderFns = []

export { render, staticRenderFns }